<template slot="header" slot-scope="scope">
<div>
  <router-link to='/authenticationadd'  class="sidebar-nav-link">
  <el-button type="primary" icon="el-icon-circle-plus-outline">申请</el-button>
    </router-link>
  <span><el-button style="float: right;margin-right: 30px;"  type="primary" @click="autSearch" size="small">查询</el-button><el-input  size="mini"  v-model="searchName" @keyup.enter.native="autSearch" placeholder="请输入企业名称" style="width: 200px;float: right;margin-right: 10px;margin-bottom: 26px;margin-top: 3px;"/></span>
    <el-table :data="tableData" style="width: 100%" max-height="1000">
    <el-table-column  prop="eName" label="企业名称" min-width="150">
    </el-table-column>
    <el-table-column prop="jperson" label="企业法人" min-width="120">
    </el-table-column>
    <el-table-column prop="updateTime" label="更新时间" min-width="120">
    </el-table-column>
      <el-table-column prop="state" label="状态" min-width="120" :formatter="stateFormat">
    </el-table-column>
    <el-table-column  label="操作">
      <template slot-scope="scope" >
        <el-button @click="handleState(scope.$index,scope.row.id,scope.row.state)" type="text" min-width="120" size="small">审核</el-button>
<router-link :to="{path:'/authenticationupdate',query:{pid:scope.row.id,currentPage:currentPage}}"  class="sidebar-nav-link" >
        <el-button type="text" size="small">编辑</el-button>
          </router-link>
      </template>
    </el-table-column>

  </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @prev-click="handleprevclick"
      @next-click="handlenextclick"
      :current-page="currentPage"
      :page-sizes="[15]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <el-dialog title="提示" :visible.sync="eventIsstate" width="300px" center>
            <div class="del-dialog-cnt">审核</div>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="isState == '0'" type="primary" @click="setIsstate" >通过并发布</el-button>
                <el-button v-if="isState == '1'" type="info" @click="setIsstate" disabled>通过并发布</el-button>
                <el-button v-if="isState == '1'" type="primary" @click="setNotstate" >撤销</el-button>
                <el-button v-if="isState == '0'" type="info" @click="setNotstate" disabled>撤销</el-button>
            </span>
        </el-dialog>
</div>

</template>

<script>
import rootPathssb from '@/api/mainApi'
// eslint-disable-next-line no-unused-vars
import { dataGetUrl, dataPost } from '@/api/index'
export default {
  name: 'authenticationlist',
  data () {
    return {
      tableData: [],
      eventIsstate: false,
      searchName: '',
      isState: '',
      delId: '',
      delIndex: '',
      pageSize: 15,
      currentPage: 1,
      total: 0,
      pagenow: 1

    }
  },
  created () {
    var that = this
    console.log(this)
    dataPost(rootPathssb.rootPath + '/admini/public/list').then(function (response) {
      that.checkSignin(response.data.result)
      console.log(response.data); console.log('bbb')
      that.tableData = response.data.info.list
      that.total = response.data.info.total
      that.pagenow = response.data.info.currentPage
    }).catch(function (error) {
      console.log(error)
      console.log('aaa')
    })
  }, // 页面加载时
  methods: {
    getPageDate (event) {
      let that = this
      let param = new URLSearchParams()
      param.append('serchname', that.searchName)
      param.append('pagenow', this.pagenow)
      dataPost(rootPathssb.rootPath + '/admini/public/list', param).then(function (response) {
        if (response.data.result === 1) {
          that.tableData = response.data.info.list
          console.log('cg')
        };console.log(response.data)
      }).catch(function (error) {
        console.log(error); console.log(2222222222)
      })
    }, // 获取数据
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val// 获取page-sizes里的每页显示几条数据的值，赋给我们自定义的每页显示数量的变量pageNum
    }, // 每页个数变化
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.pagenow = val
      this.getPageDate()
    }, // 第几页
    handleprevclick (val) {
      this.currentPage = val - 1
      this.pagenow = val - 1
      this.getPageDate()
      console.log(this)
    }, // 上一页
    handlenextclick (val) {
      this.currentPage = val + 1
      this.pagenow = val + 1
      this.getPageDate()
    }, // 下一页
    handleState (index, id, isstate) {
      this.eventIsstate = true
      this.delId = id
      this.delIndex = index
      this.isState = isstate
    }, // 发布弹窗
    setIsstate () {
      let that = this
      this.eventIsstate = false
      this.isState = '1'
      let param = new URLSearchParams()
      param.append('state', this.isState)
      param.append('id', this.delId)
      console.log(this)

      dataPost(rootPathssb.rootPath + '/admini/public/state', param).then(function (response) {
        if (response.data.result === 1) {
          console.log('cg')
          var a = that.delIndex
          that.tableData[a].state = '1'
        };
      }).catch(function (error) {
        console.log(error)
      })
    },
    setNotstate () {
      let that = this
      this.eventIsstate = false
      this.isState = '0'
      let param = new URLSearchParams()
      param.append('state', this.isState)
      param.append('id', this.delId)
      dataPost(rootPathssb.rootPath + '/admini/public/state', param).then(function (response) {
        if (response.data.result === 1) {
          console.log('cg')
          var a = that.delIndex
          that.tableData[a].state = '0'
        };
      }).catch(function (error) {
        console.log(error)
      })
    },
    stateFormat (row, column) {
      if (row.state === '1') {
        return '发布'
      } else {
        return '未发布'
      }
    }, // 状态返回
    checkSignin (sta) {
      if (sta === -1) {
        window.location.href = '/signin'
      }
    },
    autSearch () {
      var that = this
      console.log(this)
      let param = new URLSearchParams()
      param.append('serchname', that.searchName)
      dataPost(rootPathssb.rootPath + '/admini/public/list', param).then(function (response) {
        that.checkSignin(response.data.result)
        console.log(response.data); console.log('bbb')
        that.tableData = response.data.info.list
        that.total = response.data.info.total
        that.pagenow = response.data.info.currentPage
      }).catch(function (error) {
        console.log(error)
        console.log('aaa')
      })
    }
  }
}
</script>

<style >
.el-table__body-wrapper{
  max-height: 1000px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/authenticationlist.vue